import { render } from "./immobile-homepage.vue?vue&type=template&id=5ccf4f85&scoped=true"
import script from "./immobile-homepage.vue?vue&type=script&lang=js"
export * from "./immobile-homepage.vue?vue&type=script&lang=js"

import "./immobile-homepage.vue?vue&type=style&index=0&id=5ccf4f85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccf4f85"]])

export default __exports__